export const coreEn = {
  errors: {
    'intercom-load': 'Failed to load support chat',
  },
  nav: {
    gateBadge: 'Not available on your plan',
    links: {
      admin: {
        brands: 'Brands',
        gmessenger: 'Global Messenger',
        launch: 'Launch Admin',
        locations: 'Locations',
        onboarding: 'Onboarding',
        sales: 'Sales',
        users: 'Users',
      },
      apps: {
        compliance: 'Compliance',
        customers: 'Customers',
        'email-relay': 'Email Relay',
        loyalty: 'Loyalty',
        overview: 'Overview',
        reviews: 'Reviews',
      },
      marketing: {
        automations: 'Automated',
        campaigns: 'Campaigns',
        custom: 'Custom',
        lifecycle: 'Lifecycle',
        loyalty: 'Loyalty',
        otc: 'One-time',
        overview: 'Overview',
      },
      reports: {
        dashboard: 'Dashboard',
        reports: 'Reports',
      },
      restaurant: {
        careers: 'Jobs',
        coupon: 'Coupons',
        'customer-support': 'Customer support',
        delivery: 'Delivery',
        devices: 'Devices',
        feedback: 'Feedback',
        'gift-cards': 'Gift Cards',
        hours: 'Hours',
        menu: 'Menu',
        orders: 'Orders',
        stations: 'Stations',
      },
      seo: {
        'cuisines-and-keywords': 'Cuisines and keywords',
        redirects: 'Redirects',
        'seo-info': 'SEO Info',
        'seo-settings': 'SEO Settings',
      },
      staff: {
        jobs: 'Jobs',
        members: 'Members',
        pay: 'Pay',
      },
      tools: {
        acceptances: 'Acceptances',
        assignments: 'Assignments',
        'clone-menu': 'Clone Menu',
        'delete-location-brand': 'Delete Location/Brand',
        delivery: 'Delivery options',
        dns: 'DNS',
        fees: 'Owner fee',
        'gbp-training': 'GBP Training',
        'hot-launch': 'VIP Launch',
        'marketing-insights': 'Marketing Insights',
        'menu-import-json': 'Menu Import (JSON)',
        'mfa-diagnostics': '2FA Diagnostics',
        onboarding: 'Onboarding',
        'phone-ordering': 'Phone',
        'phone-tree': 'Phone Assist',
        'promo-cards': 'Promo Cards (Print Shop)',
        'prune-menu': 'Prune Menu',
        replator: 'Menu Photo Enhancer',
        scout: 'Scout',
        'scout-menus': 'Scout Menus',
        'sms-subscriber-import': 'SMS Subscriber Import',
        stations: 'Station Management',
        tips: 'Tips',
        'virtual-card': 'Apple Developer Card',
        'website-import-export': 'Website Import/Export',
        'workflow-scenarios': 'Workflow Scenarios',
      },
      website: {
        announcements: 'Announcements',
        customerAnalytics: 'Analytics',
        domains: 'Domain',
        events: 'Events',
        forms: 'Forms',
        integrations: 'Integrations',
        pages: 'Pages',
      },
    },
    options: {
      admin: {
        brands: 'Brands',
        gmessenger: 'Global Messenger',
        launch: 'Launch Admin',
        locations: 'Locations',
        onboarding: 'Onboarding',
        'photo-moderation': 'Photo Moderation',
        root: 'Admin',
        sales: 'Sales',
        users: 'Users',
      },
      agent: 'Agent',
      apps: {
        compliance: 'Compliance',
        customers: 'Customers',
        'email-relay': 'Email Relay',
        overview: 'Overview',
        reviews: 'Reviews',
        root: 'App',
      },
      'brand-kit': {
        'logo-menu': 'Logo & Menu',
        'media-gallery': 'Media Gallery',
        root: 'Brand Kit',
      },
      'brand-status': 'Brand Status',
      customers: 'Customers',
      home: 'Home',
      inbox: 'Inbox',
      launch: 'Launch',
      'launch-admin': 'Launch Admin',
      'launch-messenger': 'Messenger',
      loyalty: 'Loyalty',
      marketing: {
        automations: 'Automated',
        campaigns: 'Campaigns',
        coupon: 'Coupons',
        custom: 'Custom',
        lifecycle: 'Lifecycle',
        loyalty: 'Loyalty',
        otc: 'One-time',
        overview: 'Overview',
        'print-shop': 'Print shop',
        root: 'Marketing',
      },
      menu: 'Menu',
      orders: 'Orders',
      payments: {
        account: 'Account',
        disputes: 'Disputes',
        'gift-cards': 'Gift Cards',
        invoices: 'Invoices',
        payouts: 'Payouts',
        root: 'Payments',
        subscriptions: 'Subscriptions',
        transactions: 'Transactions',
      },
      phone: 'Phone',
      'photo-moderation': 'Photo Moderation',
      reports: 'Reports',
      sales: 'Sales',
      seo: {
        'cuisines-and-keywords': 'Cuisines and keywords',
        'gbp-inspector': 'GBP Inspector',
        'gbp-verification-help': 'GBP Verification Help',
        listings: 'Listings',
        redirects: 'Redirects',
        root: 'SEO',
        'seo-info': 'SEO Info',
        'seo-settings': 'SEO Settings',
      },
      settings: {
        brand: {
          alerts: {
            'form-submissions': 'Form submissions',
            inbox: 'Inbox',
            root: 'Alerts',
          },
          billing: {
            invoices: {
              detail: 'Invoice details',
              root: 'Invoices',
            },
            root: 'Billing',
            subscriptions: 'Subscriptions',
          },
          details: 'Brand details',
          marketing: {
            root: 'Marketing',
            'sms-marketing': 'SMS marketing',
          },
          marketplaces: {
            doordash: 'DoorDash',
            grubhub: 'Grubhub',
            root: 'Marketplaces',
            ubereats: 'Uber Eats',
          },
          'unified-loyalty': 'Unified Loyalty',
        },
        location: {
          alerts: {
            'catering-requests': 'Catering requests',
            'form-submissions': 'Form submissions',
            inbox: 'Inbox',
            root: 'Alerts',
          },
          details: 'Location details',
          devices: 'Devices',
          fees: {
            'activity-log': 'Activity log',
            root: 'Fees',
          },
          hours: {
            'activity-log': 'Activity log',
            'online-hours': {
              'edit-day': 'Edit day',
              root: 'Online hours',
            },
            root: 'Hours',
            'special-hours': {
              add: 'Add special hours',
              edit: 'Edit special hours',
              root: 'Special hours',
            },
            'store-hours': {
              'edit-day': 'Edit day',
              root: 'Store hours',
            },
          },
          integrations: {
            root: 'Integrations',
          },
          notifications: {
            'catering-requests': 'Catering requests',
            'form-submissions': 'Form submissions',
            inbox: 'Inbox',
            root: 'Notifications',
          },
          'ordering-options': {
            'activity-log': 'Activity log',
            catering: 'Catering',
            delivery: {
              'add-zone': 'Add delivery zone',
              'edit-zone': 'Edit delivery zone',
              root: 'Delivery',
            },
            kitchen: 'Kitchen',
            root: 'Orders and delivery',
          },
          payments: {
            fees: 'Fees',
            'payment-details': 'Account details',
            root: 'Payments',
          },
          phone: 'Phone',
          'phone-routing': {
            root: 'Phone routing',
          },
          'prep-time': {
            'activity-log': 'Activity log',
            'add-override': 'Add Schedule',
            'edit-override': 'Edit Schedule',
            root: 'Prep time',
            'throttle-details': 'Throttle details',
          },
          stations: {
            root: 'Stations and tablets',
            setup: {
              add: 'Add station',
              edit: 'Edit station',
              root: 'Station set up',
            },
            'tablet-permissions': 'Tablet permissions',
          },
        },
        root: 'Settings',
      },
      staff: {
        jobs: 'Jobs',
        members: 'Members',
        pay: 'Pay',
        root: 'Staff',
      },
      tools: {
        acceptances: 'Acceptances',
        assignments: 'Assignments',
        'clone-menu': 'Clone Menu',
        'delete-location-brand': 'Delete Location/Brand',
        delivery: 'Delivery options',
        dns: 'DNS',
        fees: 'Owner fee',
        'gbp-training': 'GBP Training',
        'hot-launch': 'VIP Launch',
        'marketing-insights': 'Marketing Insights',
        'menu-import-json': 'Menu Import (JSON)',
        'mfa-diagnostics': '2FA Diagnostics',
        onboarding: 'Onboarding',
        'phone-ordering': 'Phone',
        'phone-tree': 'Phone Assist',
        'promo-cards': 'Promo Cards (Print Shop)',
        'prune-menu': 'Prune Menu',
        replator: 'Menu Photo Enhancer',
        root: 'Tools',
        scout: 'Scout',
        'scout-menus': 'Scout Menus',
        'sms-subscriber-import': 'SMS Subscriber Import',
        stations: 'Station Management',
        tips: 'Tips',
        'virtual-card': 'Apple Developer Card',
        'website-import-export': 'Website Import/Export',
        'workflow-scenarios': 'Workflow Scenarios',
      },
      website: {
        agent: 'Agent',
        announcements: 'Announcements',
        careers: 'Careers',
        content: 'Content',
        'customer-support': 'Customer support',
        customerAnalytics: 'Analytics',
        domains: 'Domain',
        events: 'Events',
        feedback: 'Feedback',
        forms: 'Forms',
        pages: 'Pages',
        root: 'Website',
      },
    },
    toggles: {
      admin: 'Admin',
      agent: 'Agent',
      apps: 'Apps',
      'brand-kit': 'Brand Kit',
      'brand-status': 'Brand Status',
      customers: 'Customers',
      home: 'Home',
      inbox: 'Inbox',
      launch: 'Launch',
      'launch-admin': 'Launch Admin',
      marketing: 'Marketing',
      'photo-moderation': 'Photo Moderation',
      reports: 'Reports',
      restaurant: 'Restaurant',
      sales: 'Sales',
      seo: 'SEO',
      staff: 'Staff',
      tools: 'Tools',
      website: 'Website',
    },
  },
  pages: {
    admin: {
      brands: {
        description: 'Find the brands you need quickly.',
        title: 'Brands',
      },
      'gbp-oauth': { title: 'Owner Google Account for GBP' },
      locations: {
        description: 'Find the locations you need quickly.',
        title: 'Locations',
      },
      onboarding: { title: 'Onboarding' },
      users: { title: 'Users' },
    },
    agent: { title: 'Agent' },
    apps: {
      compliance: {
        description:
          'View compliance status for Apple and Google developer accounts.',
        title: 'Compliance',
      },
      customers: {
        description: 'Manage customer records in the embedded Owner app.',
        title: 'Customers',
      },
      'email-relay': {
        description:
          'Manage email relay settings, DNS records, and view forwarded messages.',
        title: 'Email Relay',
      },
      loyalty: {
        description:
          'See how your loyalty program is performing and tune your rewards.',
        title: 'Loyalty',
      },
      overview: {
        description: 'View your Customers overview.',
        title: 'Overview',
      },
      reviews: {
        description:
          'Browse and filter reviews from the App Store and Google Play.',
        title: 'App Reviews',
      },
    },
    auth: {
      'credential-setup': { title: 'Set Up Your Login' },
      'direct-register': { title: 'Register' },
      'forgot-password': { title: 'Forgot Password' },
      login: { title: 'Login' },
      'multi-factor-auth': { title: 'Verification Sent' },
      'multi-factor-auth-v2': { title: 'Verification Sent' },
      'multi-factor-auth-verify': { title: 'Verifying' },
      'reset-password': { title: 'Reset Password' },
    },
    billing: {
      account: {
        title: 'Account',
      },
      disputes: {
        title: 'Disputes',
      },
      invoices: {
        title: 'Invoices',
      },
      payouts: {
        title: 'Payouts',
      },
      subscriptions: {
        title: 'Subscriptions',
      },
      transactions: {
        title: 'Transactions',
      },
    },
    'brand-kit': { title: 'Brand Kit' },
    'brand-status': {
      'gbp-support': {
        description:
          'Per-location timeline and diagnostic tooling for Google Business Profile setup, verification, and recovery.',
        title: 'GBP Support',
      },
      overview: {
        description:
          'This page provides a comprehensive overview of the onboarding progress for this brand and its configuration status within our systems.',
        title: 'Brand Status',
      },
    },
    customers: { title: 'Customers' },
    fallback: { title: 'Dashboard' },
    home: { title: 'Home' },
    inbox: { title: 'Inbox' },
    launch: {
      dashboard: {
        description:
          'Manage launch configuration, locations, and team for this brand.',
        title: 'Launch Admin Dashboard',
      },
      gmessenger: {
        description:
          'Review and reply to launch conversations across all brands.',
        title: 'Global Messenger',
      },
      messenger: {
        description: 'Review and reply to launch conversations for this brand.',
        title: 'Messenger',
      },
      title: 'Launch',
    },
    marketing: {
      automations: {
        description:
          'Email and text campaigns designed and sent on your behalf by Owner.',
        title: 'Automated marketing',
      },
      campaigns: {
        description: 'Upcoming and sent one-time email and text campaigns.',
        title: 'Campaigns',
      },
      custom: {
        description: 'Create and manage custom email and text campaigns.',
        title: 'Custom marketing',
      },
      lifecycle: {
        description:
          'Recurring email and text campaigns triggered by customer behavior.',
        title: 'Lifecycle',
      },
      otc: {
        description: 'Create and manage one-time email and text campaigns.',
        title: 'One-time marketing',
      },
      overview: {
        description: 'A summary of email and text campaign performance.',
        title: 'Marketing overview',
      },
      'print-shop': {
        description:
          'Order printed materials with auto-generated QR codes for table tents, posters, promo cards, stickers, and flyers.',
        title: 'Print shop',
      },
    },
    oauth: {
      google: { title: 'Connecting Google...' },
      'google-service': { title: 'Connecting Google...' },
      stripe: { title: 'Connecting Stripe...' },
    },
    reports: {
      dashboard: { title: 'Dashboard' },
      reports: { title: 'Reports' },
    },
    'reports-v2': {
      cashDrawerHistoryReport: { title: 'Cash Drawer History' },
      costOfLaborReport: { title: 'Cost of Labor' },
      feesReport: { title: 'Fees' },
      laborReport: { title: 'Labor Summary' },
      paymentMethodsReport: { title: 'Payment Methods' },
      payoutsDetail: { title: 'Payout Detail' },
      payoutsStatsReport: { title: 'Payout Stats' },
      refundsReport: { title: 'Refunds' },
      reports: { title: 'Reports' },
      salesSummaryReport: { title: 'Sales Summary' },
      tipsReport: { title: 'Tips' },
    },
    restaurant: {
      careers: {
        description: 'Manage jobs that are advertised on your website.',
        title: 'Careers',
      },
      coupons: {
        description:
          'Create and manage coupons for orders, eligible items, or delivery fees.',
        title: 'Coupons',
      },
      'customer-support': {
        description: 'View order support requests from your customers.',
        title: 'Customer support',
      },
      delivery: {
        description:
          'Zones are listed in order of priority. Delivery availability and method will be determined by the first active zone that matches the delivery location.',
        descriptionWithCatering:
          'Zones are listed in order of priority. Delivery availability and method will be determined by the first active zone that matches the delivery location. Catering orders will only be routed to catering zones if any catering zones are configured.',
        title: 'Delivery',
      },
      devices: {
        description: 'Manage settings for your kitchen tablets.',
        title: 'Devices',
      },
      feedback: {
        description:
          'Manage and respond to feedback you receive from your website.',
        title: 'Feedback',
      },
      'gift-cards': {
        description: 'Manage your online gift cards.',
        title: 'Gift Cards',
      },
      hours: { title: 'Hours' },
      menu: {
        description: 'Set up your menu for online and mobile ordering.',
        title: 'Menu',
      },
      orders: {
        description: 'Manage your orders.',
        title: 'Orders',
      },
      stations: {
        title: 'Stations',
      },
    },
    sales: {
      approvals: {
        title: 'Quote approvals',
      },
      dashboard: {
        description:
          'Manage sales configuration, plan offerings, and location setup for this brand.',
        title: 'Sales Dashboard',
      },
    },
    'select-locations': { title: 'Select locations' },
    seo: {
      'cuisines-and-keywords': { title: 'Cuisines and keywords' },
      'gbp-inspector': { title: 'GBP Inspector' },
      'gbp-verification-help': { title: 'GBP Verification Help' },
      listings: { title: 'Listings' },
      redirects: { title: 'Redirects' },
      'seo-info': { title: 'SEO Info' },
      'seo-settings': { title: 'SEO Settings' },
    },
    settings: { title: 'Settings' },
    'settings-brand': {
      title: 'Brand Settings',
    },
    'staff-jobs': {
      description: 'Manage job postings for your restaurant.',
      title: 'Jobs',
    },
    'staff-members': {
      description: 'Manage your staff members.',
      title: 'Staff',
    },
    'staff-pay': {
      description:
        'Review staff time sheets, to view summaries for running payroll use this report.',
      title: 'Pay',
    },
    'staff-timesheets': {
      description:
        'Review staff time sheets, to view summaries for running payroll use this report.',
      title: 'Timesheets',
    },
    tools: {
      acceptances: {
        title: 'Legal Acceptances',
      },
      assignments: {
        title: 'Assignments',
      },
      'clone-menu': {
        description:
          'Clone menus from one location to another. Only eligible locations are enabled as target locations. Certain locations are disabled due to their POS integration.',
        title: 'Clone Menu',
      },
      'delete-location-brand': {
        description: 'Delete a restaurant location or brand permanently.',
        title: 'Delete Location/Brand',
      },
      delivery: {
        description:
          'Manage delivery transporation requirements for your locations.',
        title: 'Delivery options',
      },
      dns: {
        description: 'DNS tools',
        title: 'DNS',
      },
      'gbp-training': {
        actions: {
          'copy-url': 'Copy URL',
          'open-customer': 'Open',
        },
        description:
          'Simulation-only Google Business Profile training for launch specialists.',
        fields: {
          'customer-url': 'Customer simulation URL',
          location: 'Location',
          scenario: 'Scenario',
        },
        notes: {
          'customer-sees': 'Customer sees',
          'do-not-do': 'Do not do',
          'specialist-infers': 'Specialist infers',
        },
        notifications: {
          copied: 'GBP training URL copied',
        },
        preview: {
          description:
            'Read-only fixture data shown through the existing support detail component.',
          'read-only': 'Read-only',
          title: 'Specialist support preview',
        },
        'simulation-badge': 'Simulation only · dev / staging',
        title: 'GBP Training',
      },
      'hot-launch': {
        description: 'Schedule a new VIP Launch campaign.',
        title: 'VIP Launch',
      },
      'mfa-diagnostics': {
        title: '2FA Diagnostics',
      },
      onboarding: {
        description: 'Manage onboarding actions.',
        title: 'Onboarding',
      },
      'phone-ordering': {
        description:
          'Monitor incoming AI calls, conversions, transfers, and recordings at a glance.',
        title: 'Phone',
      },
      'phone-tree': {
        description:
          'Automatically direct callers to order online or route calls directly to the restaurant.',
        title: 'Setup phone assist',
      },
      'phone-tree-location-selection': {
        description: 'Select a location to setup phone assist for.',
        title: 'Phone assist',
      },
      'prune-menu': {
        description:
          'Find orphaned menu entities that are not referenced by any parent entity.',
        title: 'Prune Menu',
      },
      scout: {
        description:
          'Generate restaurant websites via Scout and monitor job status.',
        title: 'Scout',
      },
      'scout-menus': {
        description:
          'Apply Scout Golden Menu recommendations to an Integrated Menu.',
        title: 'Scout Menus',
      },
      'sms-subscriber-import': {
        description:
          'Enable SMS subscriptions for customers who previously opted in to text marketing outside of the Owner system.',
        title: 'SMS Subscriber Import',
      },
      stations: {
        description: 'Assign, unassign, and swap devices between stations',
        title: 'Station Device Management',
      },
      tips: {
        description:
          'Configure tip options for pickup, delivery, and in-store orders.',
        title: 'Tips',
      },
      'virtual-card': {
        description:
          'Manage the virtual card for Apple Developer Account renewal payments.',
        title: 'Apple Developer Card',
      },
      'website-import-export': {
        description:
          'Export the current website as JSON or import a WebsiteSpec to create a draft.',
        title: 'Website Import/Export',
      },
      'workflow-scenarios': {
        actions: {
          'copy-url': 'Copy URL',
          'open-launch': 'Open Launch',
        },
        descriptions: {
          'live-data':
            'Workflow responses come from the current backend state.',
        },
        fields: {
          'launch-url': 'Launch URL',
          location: 'Location',
          scenario: 'Scenario',
        },
        'live-data': 'Live data',
        notifications: {
          copied: 'Scenario URL copied',
        },
        title: 'Workflow Scenarios',
      },
    },
    website: {
      analytics: {
        description: 'Update analytics integration settings for your website.',
        title: 'Analytics',
      },
      announcements: {
        description: 'Add announcement banners to your website.',
        title: 'Announcements',
      },
      domains: {
        description: 'Manage and verify your website domain.',
        title: 'Domain',
      },
      events: {
        description: 'Manage events on your website.',
        title: 'Events',
      },
      forms: {
        description:
          'Add and manage forms that you can insert into website pages.',
        title: 'Forms',
      },
      integrations: { title: 'Integrations' },
      pages: {
        description: 'Manage pages in your website.',
        title: 'Pages',
      },
    },
  },
}
